export default function IconNextEpisode() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.1438 13.0968C4.14323 13.6485 3.33203 13.1966 3.33203 12.0883L3.33203 3.90988C3.33203 2.80052 4.14323 2.34921 5.1438 2.90031L12.5814 6.99985C13.5823 7.55166 13.5823 8.44569 12.5814 8.99737L5.1438 13.0968Z"
        fill="#1C1C1C" />
    </svg>
  );
}
